<style lang="stylus">
    .coupon
        position relative
        left 0
        top 0
        width 100vw
        height 100vh
        z-index 100

        .coupon-mask
            position absolute
            left 0
            top 0
            width 100%
            height 100%
            background rgba(0,0,0,.4)
            display flex
            justify-content center
            align-items center

    .couponFrameEN
        border none
        width 100%
        height 100%
        max-width 540px
        max-height 540px
        position fixed
        left 50%
        top 50%
        transform translateX(-50%) translateY(-50%)
        background #fff
        border-radius 8px
        filter drop-shadow(0px 15px 40px rgba(0, 0, 0, 0.2))
</style>

<template>
    <div class="coupon" v-if="showCouponModal">
        <div class="coupon-mask"></div>
        <template v-if="!internal">
            <iframe class="couponFrameEN" :src="iframeSrcEn" frameborder="0"></iframe>
        </template>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";

    @Component({
        components: {},
    })
    export default class Coupon extends Vue {
        showCouponModal = false;
        iframeSrcEn = "https://www.edrawsoft.com/coupon/coupon.html";
        enRule = "";

        get userInfo() {
            return this.$store.state.user.userInfo;
        }

        showCoupon() {
            this.showCouponModal = true;
        }

        closeCoupon() {
            // 关闭优惠券相关的弹窗
            this.showCouponModal = false;
        }

        closeCouponModal() {
            this.closeCoupon();
        }

        listenEvent(e) {
            if (e.data.type == "smartcoupon") {
                if (e.data.action == "close") {
                    this.closeCoupon();
                } else if (e.data.action == "openbuy") {
                    this.$openBuyPage();
                }
            }
        }

        getSmartCoupon() {
            this.$edApi
                .getSmartCoupon({
                    id: this.userInfo.user_id,
                    token: this.userInfo.token,
                    lang: this.lang == "zh" ? "cn" : this.lang,
                })
                .then((e) => {
                    let data = e.data.data;
                    if (data) {
                        // en
                        this.enRule = data.rule;
                        if (data.chance_type == 2) {
                            this.showCouponEN(true);
                            this.enRule = null;
                        }
                    }
                });
        }

        getShowRule(rule) {
            console.log("check rule");
            let couponRules: any = localStorage.getItem("couponRules"); // 当前生效rule
            let getDayInterval = (data) => {
                // 获取间隔天数
                let nowDateTime = new Date(new Date().toLocaleDateString()).getTime();
                let oldDateTime = new Date(new Date(data).toLocaleDateString()).getTime();
                if (nowDateTime < oldDateTime) return 0;
                return Math.floor((nowDateTime - oldDateTime) / (24 * 60 * 60 * 1000));
            };
            let dayFunc = (dayCount, ruleArr, alertCount, totalCount) => {
                // 根据天数规则判断是否弹出
                let day = getDayInterval(dayCount);
                if (dayCount && day < ruleArr[1]) {
                    if (totalCount == ruleArr[3]) {
                        // 弹出次数限制,等待下次循环
                        return "max";
                    }
                    if (alertCount + 1 >= ruleArr[2]) {
                        // 间隔次数满足条件,显示弹窗
                        return "show";
                    } else {
                        // 间隔次数不满足条件,不显示弹窗,间隔次数+1
                        return "add";
                    }
                } else {
                    // 清零间隔次数,显示弹窗
                    return "reset";
                }
            };
            let startFunc = (startCount, ruleArr, alertCount, totalCount) => {
                if (startCount && startCount < ruleArr[1]) {
                    if (totalCount == ruleArr[3]) {
                        // 弹出次数限制,等待下次循环
                        return "max";
                    }
                    if (alertCount + 1 >= ruleArr[2]) {
                        // 间隔次数满足条件,显示弹窗
                        return "show";
                    } else {
                        // 间隔次数不满足条件,不显示弹窗,间隔次数+1
                        return "add";
                    }
                } else {
                    // 清零间隔次数,显示弹窗
                    return "reset";
                }
            };
            let getLocal = () => {
                if (couponRules) {
                    for (let i of couponRules) {
                        if (i.id == this.userInfo.user_id) {
                            return i;
                        }
                    }
                }
                return null;
            };
            let setLocal = (obj) => {
                let index = -1;
                if (couponRules) {
                    for (let i = 0; i < couponRules.length; i++) {
                        if (couponRules[i].id == this.userInfo.user_id) {
                            Object.assign(obj, {
                                id: this.userInfo.user_id,
                            });
                            index = i;
                            couponRules.splice(i, 1, obj);
                            break;
                        }
                    }
                } else {
                    couponRules = [];
                }
                if (index == -1) {
                    Object.assign(obj, {
                        id: this.userInfo.user_id,
                    });
                    couponRules.push(obj);
                }
                localStorage.setItem("couponRules", JSON.stringify(couponRules));
            };
            if (couponRules) {
                couponRules = JSON.parse(couponRules);
            }
            let couponRule = getLocal();
            let action = "";
            let startCount = 0,
                dayCount = 0,
                alertCount = 0,
                totalCount = 0,
                oldRule = "";
            if (couponRule) {
                (startCount = Number(couponRule.startCount)),
                    (dayCount = couponRule.dayCount),
                    (alertCount = Number(couponRule.alertCount)),
                    (totalCount = Number(couponRule.totalCount)),
                    (oldRule = couponRule.oldRule);
                if (oldRule == rule) {
                    let ruleArr = rule.split("-").map((v) => Number(v));
                    if (ruleArr[0] == "0") {
                        return true;
                    } else if (ruleArr[0] == "1") {
                        action = dayFunc(dayCount, ruleArr, alertCount, totalCount);
                    } else if (ruleArr[0] == "2") {
                        // 暂时不用启动次数
                        // action = startFunc(startCount, ruleArr, alertCount, totalCount);
                        action = dayFunc(dayCount, ruleArr, alertCount, totalCount);
                    }
                } else {
                    action = "reset";
                }
            } else {
                action = "reset";
            }
            switch (action) {
                case "max":
                    return false;
                case "show":
                    setLocal({
                        startCount,
                        dayCount,
                        alertCount: 1,
                        totalCount: totalCount + 1,
                        oldRule,
                    });
                    return true;
                case "add":
                    setLocal({
                        startCount,
                        dayCount,
                        alertCount: alertCount + 1,
                        totalCount,
                        oldRule,
                    });
                    return false;
                case "reset":
                    setLocal({
                        startCount: 0,
                        dayCount: new Date(new Date().toLocaleDateString()).getTime(),
                        alertCount: 0,
                        totalCount: 1,
                        oldRule: rule,
                    });
                    return true;
            }
        }

        showCouponEN(forceShow = false) {
            if (!this.userInfo || !this.enRule) {
                return;
            }
            let userData = btoa(
                JSON.stringify({
                    id: this.userInfo.user_id,
                    token: this.userInfo.token,
                })
            );
            let isShow = forceShow ? true : this.getShowRule(this.enRule);
            this.iframeSrcEn = "https://www.edrawsoft.com/coupon/coupon.html" + `?user=${userData}&lang=${this.lang}`;
            console.log(isShow);
            isShow && this.showCoupon();
        }

        created() {
            if (!this.internal) {
                if (this.userInfo) {
                    if (!this.params || !this.params.islogin) {
                        return;
                    }
                    this.getSmartCoupon();
                } else {
                    this.$bus.$on("loginSucc", () => {
                        this.getSmartCoupon();
                    });
                }
                if (!this.internal) {
                    this.$bus.$on("showCouponEN", () => {
                        this.showCouponEN();
                    });
                }
                window.addEventListener("message", this.listenEvent);
            }
        }

        beforeDestroy() {
            window.removeEventListener("message", this.listenEvent);
            this.$bus.$off("showCouponEN");
        }
    }
</script>
<i18n>
{
  "zh": {
    "couponTitle": "福利大放送",
    "retainTitle": "专享优惠限时生效",
    "retainTip": "离开优惠即将作废，确定要离开吗？",
    "getNow": "立即领取",
    "renewNow": "立即续订",
    "leave": "残忍离开",
    "countdown": "活动倒计时"
  },
  "en": {
    "couponTitle": "Limited Time Offer",
    "retainTitle": "Don't Miss Out…",
    "retainTip": "This special offer is only available on this page. Are you sure you want to leave?",
    "getNow": "Get it now",
    "renewNow": "Renew now",
    "leave": "Leave this page",
    "countdown": "Ends on: "
  },
  "fr": {
    "tip": "Indice",
    "confirm": "Confirmer",
    "cancel": "Annuler"
  },
  "de": {
    "confirm": "Sichern",
    "cancel": "Abbrechen",
    "tip": "Hinweis"
  },
  "jp": {
    "confirm": "OK",
    "cancel": "キャンセル",
    "tip": "ご注意"
  },
  "es": {
    "tip": "Consejo",
    "confirm": "OK",
    "cancel": "Cancelar"
  },
  "pt": {
    "tip": "Ponta",
    "confirm": "OK",
    "cancel": "Cancelar"
  },
  "it": {
    "tip": "Suggerimento",
    "confirm": "OK",
    "cancel": "Annulla"
  },
  "tw": {
    "tip": "提示",
    "confirm": "確定",
    "cancel": "取消"
  },
  "kr": {
    "couponTitle": "제한 시간내에 복지 ",
    "retainTitle": "놓치지 마세요...",
    "retainTip": "이 특별 할인 혜택은 이 페이지에서만 제공됩니다. 정말 떠나시겠습니까?",
    "getNow": "즉시 수령",
    "renewNow": "즉시 주문 연장",
    "leave": "이 페이지 나가기",
    "countdown": "종료 날짜:"
  }
}
</i18n>
